// Lightweight image optimizer: for Unsplash/stock URLs, request smaller, format-optimized
// versions so pages load fast. Non-stock URLs (our object storage / generated) pass through.
export function optImg(url, w = 600, q = 68) {
  if (!url || typeof url !== "string") return url;
  if (url.includes("images.unsplash.com")) {
    const [base] = url.split("?");
    return `${base}?crop=entropy&cs=srgb&fm=jpg&auto=format&fit=crop&w=${w}&q=${q}`;
  }
  // Our object storage images: request a resized WebP variant from the backend.
  if (url.includes("/api/images/")) {
    const allowed = [160, 200, 300, 400, 500, 600, 700, 800, 1000];
    const target = allowed.find((x) => x >= w) || 1000;
    const sep = url.includes("?") ? "&" : "?";
    return `${url}${sep}w=${target}`;
  }
  return url;
}
